import React from 'react'
import type { SwitchProps } from '@chakra-ui/react'
import { HStack, Switch, Text } from '@chakra-ui/react'
import { withFormControl, type FormFieldProps } from './hoc/withFormControl'

// Component-specific props
export interface YesNoFormControlComponentProps<TValue = any> {
  variant?: SwitchProps['variant']
  defaultChecked?: boolean
  children?: React.ReactNode
  yesValue?: TValue
  noValue?: TValue
  size?: SwitchProps['size']
}

// Base component that handles yes/no switch logic
export const YesNoFormControlBase = React.forwardRef<
  HTMLInputElement,
  YesNoFormControlComponentProps & FormFieldProps<boolean | null, HTMLInputElement>
>((props, ref) => {
  const {
    // Form field props
    value,
    onChange,
    onBlur,
    isDisabled,
    name,
    // Component-specific props
    variant,
    size,
    defaultChecked,
    yesValue = true,
    noValue = false,
    children
  } = props

  const checked = (value === undefined || value === null) ? defaultChecked : value == yesValue

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked ? yesValue : noValue)
  }

  const fontSize = size === 'md' ? 'sm' : 'md'
  const fontWeight = size === 'md' ? 'normal' : 'medium'

  return (
    <HStack alignItems='center'>
      <Text fontSize={fontSize} fontWeight={fontWeight}>Ne</Text>

      <Switch
        ref={ref}
        name={name}
        isChecked={checked}
        onBlur={onBlur}
        onChange={handleChange}
        isDisabled={isDisabled}
        variant={variant}
        value={checked ? '1' : ''}
        size={size}
      />

      <Text fontSize={fontSize} fontWeight={fontWeight}>Ano</Text>
      {children}
    </HStack>
  )
})

;(YesNoFormControlBase as any).displayName = 'YesNoFormControlBase'

// Export the wrapped component
export const YesNoFormControl = withFormControl<YesNoFormControlComponentProps, boolean | null, HTMLInputElement>(YesNoFormControlBase)